import styled, { css } from "styled-components/macro";

import calloutSquiggleSVG from "components/Callout/callout_squiggle.svg";
import calloutSquiggleBottomSVG from "components/Callout/callout_squiggle_bottom.svg";
import calloutBkgroundSVG from "components/Callout/callout_bkground.svg";

interface $CalloutContainerProps {
  $position: "right" | "top";
  $size: "small" | "medium";
}

export const $CalloutContainer = styled.div<$CalloutContainerProps>`
  position: absolute;
  background: no-repeat 100%;
  /* Linear gradient with percentages is used to make ColorSun400
  fill the container from 0-95% and the final 95-100% transparent, this
  is to account for the torn edge at the bottom of the background image*/
  background-image: url(${calloutBkgroundSVG}),
    linear-gradient(${({ theme }) => theme.ColorSun400} 95%, transparent 95%);
  background-position: bottom;
  width: 8.125rem;
  padding: 1.25rem 1.25rem 1.875rem;
  ${(props) =>
    props.$size === "small" &&
    css`
      width: 6.5rem;
      padding: 0.625rem 0.625rem 0.875rem;
    `}

  &:before {
    content: "";
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
    position: absolute;
  }

  ${(props) =>
    props.$position === "right" &&
    css`
      right: -2.813rem;
      top: 1.875rem;
      transform: translateX(100%);
      &:before {
        background-image: url(${calloutSquiggleSVG});
        width: 5.125rem;
        height: 1.25rem;
        left: -4.188rem;
      }
    `};

  ${(props) =>
    props.$position === "top" &&
    css`
      right: 33%;
      bottom: calc(100% + 0.5rem);
      transform: translateX(50%);
      &:before {
        background-image: url(${calloutSquiggleBottomSVG});
        background-size: 100%;
        background-position-y: bottom;
        top: calc(100% - 0.5rem);
        left: 50%;
        transform: translateX(-50%);
        width: 1.5rem;
        height: 3.25rem;
      }
    `};
`;

export const $CalloutWrapper = styled.div`
  position: relative;
  display: inline-block;
`;
